import type { McqModel } from "../../../lib/stageViewModels";
import { BaseLine, COMPACT_FROM, Empty, ScrollCenter } from "./McqBars";
import { useGrowIn } from "./useGrowIn";

/** One dot per respondent, stacked under each option. */
export function McqDots({ model }: { model: McqModel }) {
  const { grown, reduced, delay } = useGrowIn();
  if (model.base === 0) return <Empty />;
  let running = 0;
  const compact = model.rows.length > COMPACT_FROM;
  const dot = compact ? "w-3 h-3" : "w-4 h-4";
  return (
    <div className="flex flex-col h-full text-rc-paper">
      <BaseLine label={model.baseLabel} />
      <ScrollCenter as="ul" className={compact ? "gap-3" : "gap-5"}>
        {model.rows.map((row, rowIdx) => {
          const start = running;
          running += row.count;
          return (
            <li
              key={row.key}
              className="grid grid-cols-[minmax(0,18rem)_1fr_auto] items-center gap-6"
            >
              <span
                className="font-semibold leading-tight text-balance"
                style={{ fontSize: compact ? "clamp(0.9rem, 1.2vw, 1.2rem)" : "clamp(1rem, 1.5vw, 1.5rem)" }}
              >
                {row.label}
              </span>
              <div
                className={`flex flex-wrap ${compact ? "gap-1.5" : "gap-2"}`}
                aria-label={`${row.label}: ${row.count} Personen`}
              >
                {Array.from({ length: row.count }).map((_, i) => (
                  <span
                    key={i}
                    className={`${dot} rounded-full ${row.isOther ? "bg-rc-paper/40" : rowIdx === 0 ? "bg-rc-lime" : "bg-rc-berry"} ${reduced ? "" : "transition-[transform,opacity] duration-500 ease-out"}`}
                    style={{
                      transform: grown ? "scale(1)" : "scale(0)",
                      opacity: grown ? 1 : 0,
                      transitionDelay: delay(start + i),
                    }}
                  />
                ))}
                {row.count === 0 && (
                  <span className={`${dot} rounded-full border border-rc-paper/20`} />
                )}
              </div>
              <span className="tabular-nums text-right">
                <span className={`font-bold ${compact ? "text-[1.1rem]" : "text-[1.4rem]"}`}>{row.pct}%</span>
                <span className="ml-2 text-[13px] text-rc-paper/50">
                  {row.count}
                </span>
              </span>
            </li>
          );
        })}
      </ScrollCenter>
    </div>
  );
}
